import React from "react"
import Button from "@mui/material/Button"
import {styled} from "@mui/material/styles"
import {reExportedColors} from '../index'


export default function TextButton({ children, clickHandler, disabled, variant, className, endIcon, startIcon, secondaryButton, type}) {
    return (
        <StyledButton
            className={className}
            disabled={disabled && disabled}
            onClick={clickHandler}
            variant={variant ? variant : "contained"}
            endIcon={endIcon}
            startIcon={startIcon}
            type={type}
            hasExplicitVariant={Boolean(variant)}
            secondaryButton={secondaryButton}
        >
            {children}
        </StyledButton>
    )
}

const StyledButton = styled(Button, {
    shouldForwardProp: (prop) =>
        prop !== 'hasExplicitVariant' && prop !== 'secondaryButton'
})(({theme, hasExplicitVariant, secondaryButton}) => {
    const isSecondary = !hasExplicitVariant && secondaryButton

    return {
        '&.MuiButton-root.MuiButton-contained, &.MuiButton-root.MuiButton-text, &.MuiButton-root.MuiButton-outlined': {
            color: isSecondary ? theme.palette.tertiary.main : reExportedColors.WHITE, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
            backgroundColor: isSecondary ? theme.palette.quaternary.accent : theme.palette.tertiary.accent,
            border: `2px solid ${isSecondary ? theme.palette.quaternary.accent : theme.palette.tertiary.accent}`,
            height: "35px",
            textTransform: "none",
            boxShadow: 'none',
            borderRadius: 7,
            minWidth: 80,
            '&:hover': {
                boxShadow: 'none',
                color: isSecondary ? theme.palette.tertiary.main : theme.palette.quaternary.accent,
                backgroundColor: isSecondary ? theme.palette.quaternary.accent : theme.palette.primary.accent,
                border: `2px solid ${isSecondary ? theme.palette.tertiary.main : theme.palette.secondary.accent}`,
            },
            '&.Mui-disabled': {
                color: theme.palette.action.disabled,
                backgroundColor: theme.palette.action.disabledBackground,
                borderColor: theme.palette.action.disabledBackground,
            }
        }
    }
})
